import type { Print, Product } from '@/shared/api/schemas';

/**
 * Демо-каталог: подставляется, когда API недоступен или у партнёра ещё нет
 * товаров. Нужен, чтобы каркас можно было полностью пройти — от каталога
 * до заказа — без поднятого бэкенда.
 */

// Каждому изделию нужна своя картинка и своя зона печати — они лежат
// в реестре изделий. Худи и лонгслив вернутся, когда появятся картинки:
// без них конструктор рисовал бы их футболкой.
export const DEMO_PRODUCTS: Product[] = [
  {
    id: 'demo-tshirt',
    product_type: 'tshirt',
    title: 'Футболка',
    colors: ['black', 'graphite', 'charcoal', 'navy', 'grey', 'beige', 'pink'],
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    price_rub: 2300,
    spec: {
      '1': 'Свободный крой',
      '2': 'Круглый вырез горловины из трикотажной резинки',
      '3': 'Спущенные плечи',
      '4': 'Плотность 260 гр',
      '5': 'Состав: 92% хлопок, 8% эластан',
    },
  },
  {
    id: 'demo-tote',
    product_type: 'tote',
    title: 'Шоппер',
    colors: [],
    sizes: ['ONE SIZE'],
    price_rub: 1500,
    spec: {
      '1': 'Плотный хлопок',
      '2': 'Длинные ручки',
      '3': 'Размер 35 на 40 см',
      '4': 'Плотность 240 гр',
      '5': 'Состав: 100% хлопок',
    },
  },
  {
    id: 'demo-cap',
    product_type: 'cap',
    title: 'Кепка',
    colors: [],
    sizes: ['ONE SIZE'],
    price_rub: 1900,
    spec: {
      '1': 'Пятипанельный крой',
      '2': 'Застёжка с регулировкой',
      '3': 'Изогнутый козырёк',
      '4': 'Люверсы для вентиляции',
      '5': 'Состав: 100% хлопок',
    },
  },
];


const LIBRARY: ReadonlyArray<readonly [string, string]> = [
  ['SODA LUV', 'Пули'],
  ['Imanbek', 'Roses'],
  ['ONEIL', 'Secrets'],
  ['Rompasso', 'Angetenar'],
  ['Swanky Tunes', 'Bird'],
  ['KDDK', 'Motion'],
  ['Timran', 'Ночь'],
  ['Zell', 'Контур'],
];

export const DEMO_PRINTS: Print[] = LIBRARY.map(([artist, title], index) => ({
  id: `demo-print-${index}`,
  title,
  image_url: '/brand/logo-siyai.svg',
  artist,
  collection: index < 4 ? 'Осень 2026' : 'Классика',
  // Настоящие пропорции файла: рамка принта строится по ним, и если
  // соврать здесь, вокруг картинки появятся пустые поля.
  source_width: 1970,
  source_height: 750,
}));
